var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OfferExpandedDetails',{attrs:{"criteria-options":{lot:{show: false}},"item":_vm.item}})
}
var staticRenderFns = []

export { render, staticRenderFns }